import {  GET_KM_DETAIL_ADMINTOOLS, RESET_KM_DETAIL_ADMINTOOLS } from "shared/constants/ActionTypes";

const initialState = {
  detailKm:null
};

const kmAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_KM_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailKm: action.payload,
        };
        default: {
          return state;
        }

        case RESET_KM_DETAIL_ADMINTOOLS:
          return initialState
  }
};

export default kmAdmintoolsReducer;
